import React, { useState, useEffect, useRef } from 'react';

const AnimatedCounterInView = ({ finalValue, duration }) => {
    const [count, setCount] = useState(0);
    const counterRef = useRef(null);
    const increment = Math.ceil(finalValue / duration);
    const timePerFrame = Math.ceil(duration / finalValue);
    // const [inView, setInView] = useState(false)


    useEffect(() => {
        let animationFrameId;
        let currentValue = 0;

        const animateCounter = () => {
            if (currentValue < finalValue) {
                setCount((prevCount) => prevCount + increment);
                currentValue += increment;
                animationFrameId = requestAnimationFrame(animateCounter);
            } else {
                setCount(finalValue);
            }
        };

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            // setInView(entry.isIntersecting)
            if (entry.isIntersecting && currentValue === 0) {
                animationFrameId = requestAnimationFrame(animateCounter);
            }
            else {
                setCount(0)
                currentValue = 0
            }
        });

        if (counterRef.current) {
            observer.observe(counterRef.current);
        }

        return () => {
            // observer.disconnect();
            // observer.unobserve(counterRef.current);
            // cancelAnimationFrame(animationFrameId);
          

            if (counterRef.current) {
                observer.unobserve(counterRef.current);
                cancelAnimationFrame(animationFrameId);
            }
        };
    }, [finalValue,counterRef]);

    return <div className="number" ref={counterRef}>{count}</div>;
};

export default AnimatedCounterInView;